var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { amenity, rating } = options; 
__p+='\n\n<div class="map-amenity-card">\n  <div class="map-amenity-card-wrap">\n    <div class="amenity-card-item">\n      <div class="amenity-card-label">'+
((__t=( amenity.label_display ))==null?'':__t)+
'</div>\n      ';
 if (amenity.photo_url) { 
__p+='\n      <div class="amenity-photo pull-right hidden-xs hidden-xxs">\n        <img src="'+
((__t=( amenity.photo_url ))==null?'':__t)+
'" alt="'+
((__t=( amenity.name ))==null?'':__t)+
'" />\n      </div>\n      ';
 } 
__p+='\n      <a class="amenity-card-title ellipsis" href="'+
((__t=( amenity.yelp_url ))==null?'':__t)+
'" target="_blank" data-omtag="ldp:amenities:'+
((__t=( amenityType ))==null?'':__t)+
':pop-up:site">'+
((__t=( amenity.name ))==null?'':__t)+
'</a>\n      <div class="amenity-ratings">\n        <span class="icon-amenity-rating amenity-rating-'+
((__t=( rating ))==null?'':__t)+
'"></span>\n        ';
 if (amenity.reviews_count) { 
__p+='\n        <a href="'+
((__t=( amenity.reviews_url ))==null?'':__t)+
'" class="amenity-review-count" target="_blank" data-omtag="ldp:amenities:'+
((__t=( amenityType ))==null?'':__t)+
':pop-up:review">'+
((__t=( amenity.reviews_count ))==null?'':__t)+
' Reviews</a>\n        ';
 } 
__p+='\n      </div>\n      <div class="amenity-card-address hidden-xs hidden-xxs">\n        <span>'+
((__t=( amenity.address.line_one ))==null?'':__t)+
'</span>\n        <span>'+
((__t=( amenity.address.line_two ))==null?'':__t)+
'</span>\n        <span>'+
((__t=( amenity.address.line_three ))==null?'':__t)+
'</span>\n        <span>'+
((__t=( amenity.address.city ))==null?'':__t)+
', '+
((__t=( amenity.address.state_code ))==null?'':__t)+
' '+
((__t=( amenity.address.postal_code ))==null?'':__t)+
'</span>\n      </div>\n      <div class="amenity-card-distance">'+
((__t=( amenity.address.miles_away ))==null?'':__t)+
' Miles away</div>\n      <div class="amenity-logo"></div>\n    </div> <!-- amenity-card-item -->\n  </div> <!-- map-amenity-card-wrap -->\n</div> <!-- map-amenity-card -->\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/amenity_map_card.jst.ejs